import type { ProjectStatus } from '../../data/database.types';

/**
 * The locked status vocabulary (PT §4, §21 and the design export).
 *
 * Shared by the Projects list, the create sheet and Project Home so the words
 * and marks cannot drift apart between screens. **Never colour alone** — each
 * label carries a shape and a word as well.
 */
export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  ongoing: '● ONGOING',
  finished: '✓ FINISHED',
  closed: '⊘ CLOSED',
};
